/* eslint-disable */

/** unique or primary key constraints on table "argo.user_access_token" */
export enum ArgoUserAccessTokenConstraint {
  /** unique or primary key constraint on columns "user_access_token_id" */
  UserAccessTokenPkey = 'user_access_token_pkey',
  /** unique or primary key constraint on columns "context_id", "user_id", "name" */
  UserAccessTokenUserIdNameKey = 'user_access_token_user_id_name_key'
}

/** select columns of table "argo.user_access_token" */
export enum ArgoUserAccessTokenSelectColumn {
  /** column name */
  Acls = 'acls',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id'
}

/** update columns of table "argo.user_access_token" */
export enum ArgoUserAccessTokenUpdateColumn {
  /** column name */
  Acls = 'acls',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id'
}

